export default __webpack_public_path__ + "static/media/00562c83127d3e5c.f63aa059524e2c8cb8a238ca427abe61.svg";